

































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IAgencyInfoInput } from '@/modules/Agency/interfaces/agency-form'
import { states } from '@/utils/us_states'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppPhoneInput
  }
})
export default class AgencyFormInfo extends Vue {
  @Prop({ type: Object as () => IAgencyInfoInput }) value!: IAgencyInfoInput

  states = states

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
